var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import * as actions from '../actions';
import { getActiva, getRecortes } from '../selectors';
import { FOCO_ID } from '../../herramientas/constantes';
import Cartulina from '../components/cartulina';
var CONFIG_CARTULINA_DEFECTO = {
  color: '#000000',
  colorTransparente: 'rgb(0, 0, 0, 0.4)',
  resolucion: {
    ancho: 1000,
    alto: 1000
  },
  minRecorte: {
    ancho: 2,
    alto: 2
  }
};

var getConfigCartulina = function getConfigCartulina(state) {
  var botonFoco = state.barraHerramientas.botones.find(function (_ref) {
    var id = _ref.id;
    return id === FOCO_ID;
  });

  if (!botonFoco) {
    return CONFIG_CARTULINA_DEFECTO;
  }

  return _extends({}, CONFIG_CARTULINA_DEFECTO, botonFoco);
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getConfigCartulina = getConfigCartulina(state),
      color = _getConfigCartulina.color,
      colorTransparente = _getConfigCartulina.colorTransparente,
      resolucion = _getConfigCartulina.resolucion,
      minRecorte = _getConfigCartulina.minRecorte;

  return {
    activa: getActiva(state),
    color: color,
    colorTransparente: colorTransparente,
    resolucion: {
      width: resolucion.ancho,
      heigth: resolucion.alto
    },
    minRecorte: {
      w: minRecorte.ancho,
      h: minRecorte.alto
    },
    recortes: getRecortes(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onNuevoRecorte: function onNuevoRecorte(_ref2) {
      var x = _ref2.x,
          y = _ref2.y,
          w = _ref2.w,
          h = _ref2.h;
      return dispatch(actions.crearRecorte(x, y, w, h));
    },
    onRecortes: function onRecortes(recortes) {
      return dispatch(actions.recortes(recortes));
    }
  };
};

var CartulinaContainer = connect(mapStateToProps, mapDispatchToProps)(Cartulina);
export default CartulinaContainer;